<template>
	<div>
		<SpinLoader v-if="loading" />
		<div v-if="!loading && !data.items.length" class="text-center">
			<template v-if="data.type == 'FAVORITE' && !search">
				<div class="d-flex flex-column justify-center align-center" :style="{ height: getFavHeight }">
					<img src="@/assets/images/favorite-mascott.png" />
					<div class="fs--13 fw--600 px-5 mt-4 empty-favorite-text">
						<span class="reward-text fs--13 fw--600">Tap the</span>&nbsp;<span class="white--text"
							>Heart Icon</span
						>&nbsp;<span class="reward-text fs--13 fw--600">on any sticker to save it as a</span>&nbsp;<span
							class="white--text"
							>favorite</span
						><span class="reward-text fs--13 fw--600">! Your favorite stickers will appear here!</span>
					</div>

					<div class="mt-1 d-flex align-center justify-center">
						<img :src="require(`@/assets/icons/favorite/${theme}.png`)" />
						<v-icon color="white" class="mx-1">{{ mdiChevronRight }}</v-icon>
						<img src="@/assets/icons/favorite/heart.png" />
					</div>
				</div>
			</template>
			<template v-else>
				<div class="mt-3 text-center">
					<span class="reward-text fs--13 fw--600">No Stickers Found.</span>
				</div>
			</template>
		</div>

		<div v-if="!loading && data.items.length > 0">
			<!-- Reward Stickers -->
			<v-row v-if="stickerType && stickerType == StickerType.REWARD" no-gutters class="mx-2">
				<v-col cols="12" class="text-center px-7" :class="[size === 'md' && 'md-heading']">
					<p class="reward-text fs--13 fw--600 mb-0">
						Unlock the ability to use these rewards on
						<span class="white--text">{{ streamerDisplayName }}'s</span> channel!
					</p>
				</v-col>
				<v-col
					:cols="size === 'sm' ? 12 : 6"
					class="reward-stickers mt-0"
					:class="size === 'md' && 'px-1'"
					v-for="s in stickers"
					:key="s.id">
					<StickerReward :id="s.id" :sticker="s" @onStickerClick="actions.onStickerClick" />
				</v-col>
			</v-row>

			<!-- TTS Stickers -->

			<v-row v-else-if="stickerType && stickerType == StickerType.TTS" class="stickers mx-0" no-gutters>
				<v-col v-for="s in stickers" :key="s.id" :cols="size === 'sm' ? 6 : 4" class="pb-2 px-1">
					<StickerTTS
						:id="s.id"
						:sticker="s"
						@onStickerClick="actions.onStickerClick"
						@onAddFavorite="actions.onAddFavorite"
						@onDeleteFavorite="actions.onDeleteFavorite" />
				</v-col>
			</v-row>

			<v-row
				v-else-if="!stickerType || (stickerType != StickerType.REWARD && stickerType != StickerType.TTS)"
				class="stickers mx-0"
				no-gutters>
				<v-col v-for="s in stickers" :key="s.id" :cols="size === 'sm' ? 6 : 4" class="pb-2 px-1">
					<template v-if="s.stickerType === StickerType.TTS">
						<StickerTTS
							:id="s.id"
							:sticker="s"
							@onStickerClick="actions.onStickerClick"
							@onAddFavorite="actions.onAddFavorite"
							@onDeleteFavorite="actions.onDeleteFavorite" />
					</template>
					<template v-else>
						<Sticker
							:id="s.id"
							:sticker="s"
							@onPlaySound="actions.onPlaySound"
							@onStickerClick="actions.onStickerClick"
							@onAddFavorite="actions.onAddFavorite"
							@onDeleteFavorite="actions.onDeleteFavorite" />
					</template>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import { computed, ref } from 'vue';
import { useStore } from '@/store';
import SpinLoader from '@/components/panel/SpinLoader';
import StickerReward from '@/components/panel/Stickers/StickerReward.vue';
import Sticker from '@/components/panel/Stickers/Sticker.vue';
import StickerTTS from '@/components/panel/Stickers/StickerTTS.vue';
import { StickerType } from '@/utils/constants';
import { mdiChevronRight } from '@mdi/js';
export default {
	name: 'AllStickers',
	components: {
		StickerReward,
		Sticker,
		StickerTTS,
		SpinLoader,
	},
	props: {
		data: Object,
		search: String,
		// see constants.js:StickerType
		stickerType: {
			type: String,
			required: false,
		},
		loading: Boolean,
	},
	emits: ['onStickerClick', 'onAddFavorite', 'onDeleteFavorite', 'onPlaySound'],
	setup(props, ctx) {
		const clickedSticker = ref(null);
		const store = useStore();

		const isMobile = computed(() => store.state.isMobile);
		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);

		const currentPage = computed(() => store.state.currentPage);

		const getFavHeight = computed(() => {
			const stickerTab = document.querySelector('.sticker-tab');
			if (!isMobile.value) {
				if (stickerTab.offsetHeight <= 318) {
					return '290px';
				}

				return '360px';
			} else {
				return '360px';
			}
		});

		const stickers = computed(() => {
			let stickerItems = [];

			if (!props.stickerType) {
				// Sort Stickers by HOT, TTS, CUSTOM, REWARD, and Others

				const hotItems = props.data.items.filter(item => item.stickerType === StickerType.GLOBAL && item.isHot);

				const ttsItems = props.data.items.filter(item => item.stickerType === StickerType.TTS);

				const customItems = props.data.items.filter(item => item.stickerType === StickerType.CUSTOM);

				const rewardItems = props.data.items.filter(item => item.stickerType === StickerType.REWARD);

				const others = props.data.items.filter(
					item =>
						item.stickerType !== StickerType.REWARD &&
						item.stickerType !== StickerType.CUSTOM &&
						item.stickerType !== StickerType.TTS &&
						!(item.stickerType === StickerType.GLOBAL && item.isHot),
				);

				stickerItems = [...hotItems, ...ttsItems, ...customItems, ...rewardItems, ...others];

				return stickerItems;

				// if (!store.state.isMobile) {
				// 	const start = currentPage.value * props.data.perPage,
				// 		end = start + props.data.perPage;
				// 	return stickerItems.slice(start, end);
				// } else {
				// 	return stickerItems;
				// }
			} else {
				// if (!store.state.isMobile) {
				// 	const start = currentPage.value * props.data.perPage,
				// 		end = start + props.data.perPage;
				// 	return props.data.items.slice(start, end);
				// } else {
				// 	return props.data.items;
				// }

				return props.data.items;
			}
		});

		const actions = {
			onStickerClick(sticker) {
				clickedSticker.value = null;
				clickedSticker.value = { ...sticker };
				ctx.emit('onStickerClick', clickedSticker.value);
			},
			onPlaySound(sticker) {
				ctx.emit('onPlaySound', { ...sticker });
			},
			onAddFavorite(data) {
				ctx.emit('onAddFavorite', data);
			},
			onDeleteFavorite(data) {
				ctx.emit('onDeleteFavorite', data);
			},
		};

		const streamerDisplayName = computed(() => {
			return store.state.streamerDisplayName;
		});

		const bitsCreditAmount = computed(() => {
			return store.state.bitsCreditAmount;
		});

		return {
			actions,
			size,
			theme,
			getFavHeight,
			stickers,
			StickerType,
			streamerDisplayName,
			mdiChevronRight,
			bitsCreditAmount,
		};
	},
};
</script>

<style scoped>
.empty-favorite-text {
	line-height: 0.5rem;
}
</style>
